module.exports = __webpack_public_path__ + "img/create-treatment-button-fr.60426477.png";